(function () {
  function applyPatch(inner, alignLeft) {
    if (!inner || !inner.shadowRoot) return;

    if (!inner.shadowRoot.querySelector('style[data-leonie]')) {
      var s = document.createElement('style');
      s.setAttribute('data-leonie', '1');
      var columnCSS = alignLeft
        ? '.wrapper { justify-content: flex-start !important; margin-left: 0 !important; } .content { flex-wrap: nowrap !important; flex-direction: row !important; align-items: center !important; } .content > * { white-space: nowrap !important; flex-shrink: 0 !important; } .grade-summary { display: none !important; } .grade-count { display: none !important; }'
        /* Announcement-Bar: immer einzeilig — verhindert das gestapelte Groß-Layout
           auf Mobil (Sterne riesig, "4,78" umbrochen) */
        : '.content { flex-wrap: nowrap !important; flex-direction: row !important; align-items: center !important; } .content > * { white-space: nowrap !important; flex-shrink: 0 !important; }';
      s.textContent = '.wrapper { margin-top: 6px !important; margin-bottom: 6px !important; } .grade-value, .grade-summary, .grade-count { color: #ffffff !important; } ' + columnCSS;
      inner.shadowRoot.appendChild(s);
    }

    var wrapper = inner.shadowRoot.querySelector('.wrapper');
    if (wrapper) {
      wrapper.style.setProperty('margin-left', '0', 'important');
      wrapper.style.setProperty('margin-top', '6px', 'important');
      wrapper.style.setProperty('margin-bottom', '6px', 'important');
      if (alignLeft) wrapper.style.setProperty('justify-content', 'flex-start', 'important');
    }

    inner.style.setProperty('--accent-color', '#ffffff');

    var starRating = inner.shadowRoot.querySelector('etrusted-tss-star-rating');
    if (starRating) {
      starRating.style.setProperty('--accent-color', '#ffffff');
      if (starRating.shadowRoot && !starRating.shadowRoot.querySelector('style[data-leonie]')) {
        var ss = document.createElement('style');
        ss.setAttribute('data-leonie', '1');
        ss.textContent = 'svg path, svg polygon, svg rect, svg circle, * { fill: #ffffff !important; color: #ffffff !important; }';
        starRating.shadowRoot.appendChild(ss);
      }
    }
  }

  function patchOne(outer) {
    if (!outer || !outer.shadowRoot) return false;
    // Footer: Testimonial-Widget bleibt im Default-Look. Der Klick aufs echte
    // Trusted-Shops-Profil ist NICHT hier gelöst, sondern als <a>-Wrapper direkt im
    // HTML (sections/footer.liquid) — Light-DOM, damit er auch ohne Consent bzw. bei
    // geschlossenem Shadow-Root immer greift. Hier nur als erledigt markieren
    // (return true), damit der initPatch-Retry-Loop stoppt.
    if (outer.closest('.cc-footer')) return true;
    // Nur das Widget in der Announcement-Bar weiß stylen. Andere Sterne-Widgets desselben
    // Typs (z.B. dieselbe ID auf der PDP) bleiben im Default-Look (orange/dunkel), damit sie
    // auf hellem Grund sichtbar sind.
    if (!outer.closest('.cc-announcement')) return true;
    var inner = outer.shadowRoot.querySelector('etrusted-trusted-stars-service-widget');
    if (!inner || !inner.shadowRoot) return false;
    var alignLeft = !!outer.closest('.cc-footer');
    applyPatch(inner, alignLeft);
    var observer = new MutationObserver(function () { applyPatch(inner, alignLeft); });
    observer.observe(inner, { attributes: true, attributeFilter: ['style'] });
    // Auch Re-Renders im Shadow DOM abfangen (Widget baut .wrapper neu, wenn Daten spät kommen)
    var shadowObserver = new MutationObserver(function () { applyPatch(inner, alignLeft); });
    shadowObserver.observe(inner.shadowRoot, { childList: true, subtree: true });
    setTimeout(function () { applyPatch(inner, alignLeft); }, 2000);
    return true;
  }

  function initPatch() {
    var outers = document.querySelectorAll('etrusted-widget');
    var allDone = true;
    outers.forEach(function (outer) {
      if (!outer.dataset.leoniePatchDone) {
        if (patchOne(outer)) {
          outer.dataset.leoniePatchDone = '1';
        } else {
          allDone = false;
        }
      }
    });
    if (!allDone) setTimeout(initPatch, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initPatch, 300); });
  } else {
    setTimeout(initPatch, 300);
  }
})();
